import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import NewButton, { Props } from '../_components/NewButton';
import { NewPattern } from '../../Sidebar/_actions/SidebarActions';
import { NewDocument } from '../../Sidebar/_actions/SidebarActions';
import { OnLayerAdd } from '../../LayerList/_actions/LayerListActions';
import { OnIntroOpen } from '../../Intro/_actions/IntroActions';

const mapDispatchToProps = (dispatch: Dispatch, props: Props) => ({
	onNewPattern: (fd: FormData) => {
		dispatch(NewPattern()),
		dispatch(NewDocument()),
		dispatch(OnLayerAdd())
	},
	setIntroOpen: (opened: boolean) => dispatch(OnIntroOpen(opened)),
});

export default connect(
	null,
	mapDispatchToProps
)(NewButton);